import React from 'react';

import * as S from './styled';

const HomeFooter = () => (
    <S.FooterWrapper>
        footer
    </S.FooterWrapper>
);

export default HomeFooter;